import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import DashboardMenuItem from '../../common/dashboard_menu_item/dashboard_menu_item';

class Navigation extends Component {
  get selectedKeys() {
    return this.props.location.pathname.match(this.props.configs.map((config) => config.path).join('|'));
  }

  get content() {
    return this.props.configs.filter((config) => !config.excludeFromMenu)
      .map((config) => <DashboardMenuItem key={config.path} { ...config } />)
  }

  render() {
    return (
      <Menu mode="inline" selectedKeys={this.selectedKeys}>
        {this.content}
      </Menu>
    )
  }
}

export default withRouter(Navigation);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/navigation.js